/* event tracking for i,s,o,g,r,a,m google analytics tracker */

//vars
var first_time_end,first_time_half;
var minutes_past = 0;

//functions
var trackEvent = function(type, label){
    ga('send', 'event', type, label);
    //console.log("ga('send', 'event', '"+type+"', '"+label+"');");
}
var loadEvents = function(){
    trackOneMinute();
    trackContactLinks();
}
var scrollEvents = function(){
    var scroll_pos = $(window).scrollTop();
    var wh = $(window).height();
    var dh = $(document).height();
    if(dh>wh){
        if((scroll_pos + wh) === dh && !first_time_end){
            first_time_end = true;
            trackEvent('Scroll','Page end');
        }else if((scroll_pos + wh) >= dh/2 && !first_time_half){
            first_time_half = true;
            trackEvent('Scroll','Page half');
        }
    }
}
var trackOneMinute = function(){
    setTimeout(function(){
        if(minutes_past<10){
            minutes_past++;
            trackEvent('Time on site',minutes_past+' minutes past');
            trackOneMinute();
        }
    },60000);
}
var trackContactLinks = function(){
    $('a[href^="mailto:"],a[href^="tel:"]').bind('mouseup',function(){
        var href = $(this).attr('href');
        trackEvent('Contact link',href);
    });
}
//initiate on load
$(window).load(loadEvents);

//initiate on scroll
$(window).scroll(scrollEvents);

